export var CreateMultTypes;
(function (CreateMultTypes) {
    CreateMultTypes["createUser"] = "createUser";
    CreateMultTypes["attachUser"] = "attachUser";
})(CreateMultTypes || (CreateMultTypes = {}));
//# sourceMappingURL=types.js.map